import request from '@/plugins/axios'

// 查询流程分页
export function auditProcessCsPage(data) {
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/page',
        method: 'post',
        data: data
    })
}

// 查询流程列表
export function auditProcessCsList(data) {
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/list',
        method: 'post',
        data: data
    })
}

// 查询流程详细
export function auditProcessCsDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/detail',
        method: 'post',
        data
    })
}

export function auditProcessCsAdd(data) {
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/add',
        method: 'post',
        data
    })
}

export function auditProcessCsUpdate(data) {
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/update',
        method: 'post',
        data
    })
}

export function auditProcessCsDelete(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcessDuplicate/v1.0.0/delete',
        method: 'post',
        data
    })
}
